/**
 * Cadastro Lev storefront app.
 * UI and /cadastrolev-assets/* media live in the Shopify theme. APIs stay on Netlify.
 */
(function () {
  'use strict';

  var ROOT = document.getElementById('lev-cadastrolev-root');
  if (!ROOT) return;

  var API_BASE = String(ROOT.getAttribute('data-api-base') || '').replace(/\/$/, '');
  var ASSET_BASE = String(ROOT.getAttribute('data-asset-base') || API_BASE).replace(/\/$/, '');
  var WA = String(ROOT.getAttribute('data-wa-number') || '5521980220130').replace(/\D/g, '');
  var PDF_CRUISER = String(ROOT.getAttribute('data-pdf-cruiser') || '').trim();
  var PDF_ONN = String(ROOT.getAttribute('data-pdf-onn') || '').trim();
  var PDF_GUIA = String(ROOT.getAttribute('data-pdf-guia') || '').trim();

  var STEP = {
    INICIO: 1,
    CADASTRO: 2,
    NOTA_FISCAL: 2.5,
    HOWTO: 3,
    QRCODE: 4,
    SERIE: 5,
    ERRO_SERIE: 6,
    ERRO_ATIVADA: 6.5,
    VALIDADO: 7,
    CONFERIR_NF: 8,
    FINAL: 9,
  };

  var PAGE_NAMES = {};
  PAGE_NAMES[STEP.INICIO] = 'Page1Inicio';
  PAGE_NAMES[STEP.CADASTRO] = 'Page2Cadastro';
  PAGE_NAMES[STEP.NOTA_FISCAL] = 'PageNotaFiscal';
  PAGE_NAMES[1.5] = 'PageNotaFiscal';
  PAGE_NAMES[STEP.HOWTO] = 'Page3HowTo';
  PAGE_NAMES[STEP.QRCODE] = 'Page4QRCode';
  PAGE_NAMES[STEP.SERIE] = 'Page5DigiteNumeroSerie';
  PAGE_NAMES[STEP.ERRO_SERIE] = 'Page6ErroNumeroInvalido';
  PAGE_NAMES[STEP.ERRO_ATIVADA] = 'Page6ErroBikeAtivada';
  PAGE_NAMES[STEP.VALIDADO] = 'Page7NumeroValido';
  PAGE_NAMES[STEP.CONFERIR_NF] = 'PageNotaConferir';
  PAGE_NAMES[STEP.FINAL] = 'Page8Final';

  var NEXT = {};
  NEXT[STEP.INICIO] = STEP.CADASTRO;
  NEXT[STEP.CADASTRO] = STEP.NOTA_FISCAL;
  NEXT[STEP.NOTA_FISCAL] = STEP.HOWTO;
  NEXT[STEP.HOWTO] = STEP.QRCODE;
  NEXT[STEP.QRCODE] = STEP.SERIE;
  NEXT[STEP.SERIE] = STEP.ERRO_SERIE;
  NEXT[STEP.ERRO_SERIE] = STEP.SERIE;
  NEXT[STEP.ERRO_ATIVADA] = STEP.SERIE;
  NEXT[STEP.VALIDADO] = STEP.FINAL;
  NEXT[STEP.CONFERIR_NF] = STEP.FINAL;
  NEXT[STEP.FINAL] = STEP.FINAL;

  var PREV = {};
  PREV[STEP.INICIO] = STEP.INICIO;
  PREV[STEP.CADASTRO] = STEP.INICIO;
  PREV[STEP.NOTA_FISCAL] = STEP.CADASTRO;
  PREV[STEP.HOWTO] = STEP.NOTA_FISCAL;
  PREV[STEP.QRCODE] = STEP.HOWTO;
  PREV[STEP.SERIE] = STEP.QRCODE;
  PREV[STEP.ERRO_SERIE] = STEP.SERIE;
  PREV[STEP.ERRO_ATIVADA] = STEP.SERIE;
  PREV[STEP.VALIDADO] = STEP.SERIE;
  PREV[STEP.CONFERIR_NF] = STEP.VALIDADO;
  PREV[STEP.FINAL] = STEP.FINAL;

  var SESSION_KEY = 'cadastrolev_sessao';
  var NF_DRAFT_KEY = 'cadastrolev_nf_draft';
  var FORM_KEY = 'cadastrolev_page2_form_data';
  var TTL_MS = 2 * 60 * 60 * 1000;
  var cepRequestSequence = 0;
  var lastRequestedCep = '';

  var MODEL_DATA = {
    cruiser: {
      label: 'Model C',
      image: '/cadastrolev-assets/bikes/cruiser-c-preto.png',
      pdf: PDF_CRUISER || '/pdfs/MANUAIS_CADASTRO/[0206]MANUAL_CRUISER_C.pdf',
      videos: [
        { title: 'Tutorial de Montagem Model C', embed: 'https://player.vimeo.com/video/1203526765?h=93a9bbe007&badge=0&autopause=0' },
        { title: 'Tutorial de Uso Model C', embed: 'https://player.vimeo.com/video/1203526765?h=93a9bbe007&badge=0&autopause=0' },
      ],
    },
    ebike: {
      label: 'P 500',
      image: '/cadastrolev-assets/bikes/onn-p500-preto.png',
      pdf: PDF_ONN || '/pdfs/MANUAIS_CADASTRO/[1206] MANUAL_ONN.pdf',
      videos: [
        { title: 'Tutorial de Montagem P 500', embed: 'https://player.vimeo.com/video/1204897622?h=2db1126ca8&badge=0&autopause=0' },
        { title: 'Tutorial de Uso P 500', embed: 'https://player.vimeo.com/video/1203530311?h=4c61cbe51a&badge=0&autopause=0' },
      ],
    },
    ebikes: {
      label: 'P 1000',
      image: '/cadastrolev-assets/bikes/onn-p1000-branco.png',
      pdf: PDF_ONN || '/pdfs/MANUAIS_CADASTRO/[1206] MANUAL_ONN.pdf',
      videos: [
        { title: 'Tutorial de Montagem P 1000', embed: 'https://player.vimeo.com/video/1204897620?h=472504f84d&badge=0&autopause=0' },
        { title: 'Tutorial de Uso P 1000', embed: 'https://player.vimeo.com/video/1203529854?h=43c44e0cbe&badge=0&autopause=0' },
      ],
    },
  };

  var state = {
    view: 'home',
    step: STEP.INICIO,
    flowType: window.matchMedia('(min-width: 561px)').matches ? 'desktop' : 'mobile',
    cadastroId: null,
    personalData: {},
    bikeSerialNumber: '',
    bikeData: null,
    bikeImage: null,
    nfDraft: null,
    alreadyActivated: false,
    errorReason: '',
    validationMessage: '',
    busy: false,
    menuOpen: false,
    corsHint: false,
    nfWhatsapp: false,
    montagemModel: 'cruiser',
    statusMsg: '',
  };

  function asset(path) {
    if (!path) return '';
    if (/^(?:https?:)?\/\//i.test(path)) return path;
    if (path.charAt(0) === '/' && path.indexOf('/cdn/') === 0) return path;
    var mapped = window.LEV_CADASTROLEV_ASSETS && window.LEV_CADASTROLEV_ASSETS[path];
    if (mapped) return mapped;
    return ASSET_BASE + (path.charAt(0) === '/' ? path : '/' + path);
  }

  function guiaPdf() {
    return PDF_GUIA || asset('/guia-de-boas-praticas.pdf');
  }

  function api(path) {
    return API_BASE + (path.charAt(0) === '/' ? path : '/' + path);
  }

  function getPageName(step) {
    return PAGE_NAMES[step] || 'Page' + step;
  }

  function nextStep(current) {
    return NEXT[current] != null ? NEXT[current] : STEP.CADASTRO;
  }

  function prevStep(current) {
    return PREV[current] != null ? PREV[current] : STEP.INICIO;
  }

  function prevStepForFlow(current, flowType) {
    if (
      flowType === 'desktop' &&
      (current === STEP.VALIDADO ||
        current === STEP.ERRO_SERIE ||
        current === STEP.ERRO_ATIVADA ||
        current === STEP.SERIE)
    ) {
      return STEP.HOWTO;
    }
    return prevStep(current);
  }

  function routeAfterValidation(outcome) {
    if (outcome.alreadyActivated) return STEP.ERRO_ATIVADA;
    if (outcome.hasBikeData) return STEP.VALIDADO;
    return STEP.ERRO_SERIE;
  }

  function etapaSegura(etapa) {
    if (!Number.isFinite(etapa)) return STEP.INICIO;
    if (etapa <= STEP.INICIO) return STEP.INICIO;
    if (etapa === 1.5 || etapa === STEP.NOTA_FISCAL) return STEP.NOTA_FISCAL;
    if (etapa === STEP.CONFERIR_NF || etapa >= STEP.FINAL) return STEP.VALIDADO;
    return Math.min(etapa, STEP.HOWTO);
  }

  function readJson(key) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeJson(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* private mode */
    }
  }

  function clearKey(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      /* ignore */
    }
  }

  function salvarSessao() {
    if (!state.cadastroId) return;
    writeJson(SESSION_KEY, {
      cadastroId: state.cadastroId,
      personalData: state.personalData || {},
      bikeSerialNumber: state.bikeSerialNumber || '',
      etapa: state.step,
      flowType: state.flowType,
      nfDraft: state.nfDraft || null,
      salvoEm: Date.now(),
    });
  }

  function limparSessao() {
    clearKey(SESSION_KEY);
    clearKey(NF_DRAFT_KEY);
    try {
      localStorage.removeItem(FORM_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function restaurarSessao() {
    var sessao = readJson(SESSION_KEY);
    if (!sessao || !sessao.cadastroId || typeof sessao.salvoEm !== 'number') return;
    if (Date.now() - sessao.salvoEm > TTL_MS) {
      limparSessao();
      return;
    }
    state.cadastroId = sessao.cadastroId;
    state.personalData = sessao.personalData || {};
    state.bikeSerialNumber = sessao.bikeSerialNumber || '';
    state.flowType = sessao.flowType === 'desktop' ? 'desktop' : state.flowType;
    state.nfDraft = sessao.nfDraft || readJson(NF_DRAFT_KEY);
    state.step = etapaSegura(sessao.etapa);
    state.view = 'registro';
  }

  async function apiFetch(path, options) {
    var opts = options || {};
    opts.headers = Object.assign(
      { 'Content-Type': 'application/json', Accept: 'application/json' },
      opts.headers || {}
    );
    opts.mode = 'cors';
    opts.credentials = 'omit';
    try {
      var res = await fetch(api(path), opts);
      return res;
    } catch (err) {
      state.corsHint = true;
      throw err;
    }
  }

  async function updateEtapaAPI(cadastroId, pageName) {
    if (!cadastroId) return false;
    try {
      await apiFetch('/api/update-etapa', {
        method: 'POST',
        body: JSON.stringify({ cadastroId: cadastroId, pagina_atual: pageName }),
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  async function updateCupom(cadastroId) {
    if (!cadastroId) return false;
    try {
      await apiFetch('/api/update-cupom', {
        method: 'POST',
        body: JSON.stringify({ cadastroId: cadastroId, cupom: true }),
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  async function updateStatus(cadastroId, status) {
    if (!cadastroId) return false;
    try {
      await apiFetch('/api/update-etapa-milestone', {
        method: 'POST',
        body: JSON.stringify({ cadastroId: cadastroId, status: status }),
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function maskCpf(value) {
    var d = onlyDigits(value).slice(0, 11);
    return d
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  function maskPhone(value) {
    var d = onlyDigits(value).slice(0, 11);
    if (d.length <= 10) {
      return d.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
    }
    return d.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
  }

  function maskCep(value) {
    var d = onlyDigits(value).slice(0, 8);
    return d.replace(/(\d{5})(\d)/, '$1-$2');
  }

  function isValidCpf(cpf) {
    var s = onlyDigits(cpf);
    if (s.length !== 11 || /^(\d)\1+$/.test(s)) return false;
    var sum = 0;
    var i;
    for (i = 0; i < 9; i++) sum += Number(s[i]) * (10 - i);
    var r = (sum * 10) % 11;
    if (r === 10) r = 0;
    if (r !== Number(s[9])) return false;
    sum = 0;
    for (i = 0; i < 10; i++) sum += Number(s[i]) * (11 - i);
    r = (sum * 10) % 11;
    if (r === 10) r = 0;
    return r === Number(s[10]);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function customerMessage(value, fallback) {
    var message = String(value || '').trim();
    if (!message || /[_{}\[\]]/.test(message)) return fallback;
    return message.replace(/sankhya|supabase|n8n/gi, 'sistema da Lev');
  }

  function logoHtml(center) {
    return (
      '<div class="lev-cadastrolev__header' +
      (center ? ' lev-cadastrolev__header--center' : '') +
      '">' +
      '<img class="lev-cadastrolev__logo" src="' +
      escapeHtml(asset('/cadastrolev-assets/logo-grupo.svg')) +
      '" alt="Grupo Lev" width="255" height="64">' +
      (center ? '' : menuButtonHtml()) +
      '</div>'
    );
  }

  function menuButtonHtml() {
    return '<button type="button" class="lev-cadastrolev__menu-btn" data-action="menu" aria-label="Menu"><span></span><span></span><span></span></button>';
  }

  function flowHeaderHtml(activeSteps, extraClass) {
    return (
      '<div class="lev-cadastrolev__flow-header' +
      (extraClass ? ' ' + extraClass : '') +
      '">' +
      '<button type="button" class="lev-cadastrolev__flow-back" data-action="prev">' +
      '<span><img src="' +
      escapeHtml(asset('/cadastrolev-assets/arrow-left.svg')) +
      '" alt="" width="12" height="12"></span>Voltar</button>' +
      progress(activeSteps) +
      menuButtonHtml() +
      '</div>'
    );
  }

  function validatedHeaderHtml() {
    return (
      '<div class="lev-cadastrolev__flow-header lev-cadastrolev__validated-header">' +
      '<button type="button" class="lev-cadastrolev__flow-back" data-action="prev">' +
      '<span><img src="' +
      escapeHtml(asset('/cadastrolev-assets/arrow-left.svg')) +
      '" alt="" width="10" height="18"></span>Voltar</button>' +
      progress(5, 5) +
      menuButtonHtml() +
      '</div>'
    );
  }

  function dots(activeIndex, total) {
    return (
      '<div class="lev-cadastrolev__carousel-indicator" aria-hidden="true"><img src="' +
      escapeHtml(asset('/cadastrolev-assets/estado-carrossel.svg')) +
      '" alt="" width="62" height="2"></div>'
    );
  }

  function progress(activeSteps, totalSteps) {
    var html = '<div class="lev-cadastrolev__progress" aria-label="Progresso do cadastro">';
    var i;
    var total = totalSteps || 4;
    for (i = 0; i < total; i++) {
      html +=
        '<span class="lev-cadastrolev__progress-segment' +
        (i < activeSteps ? ' is-active' : '') +
        '"></span>';
    }
    return html + '</div>';
  }

  function corsBanner() {
    if (!state.corsHint) return '';
    return (
      '<p class="lev-cadastrolev__cors-warn">Não foi possível conectar agora. Confira sua internet e tente novamente.</p>'
    );
  }

  function drawerHtml() {
    return (
      '<div class="lev-cadastrolev__drawer' +
      (state.menuOpen ? ' is-open' : '') +
      '" data-action="close-menu">' +
      '<div class="lev-cadastrolev__drawer-panel" role="dialog" aria-label="Menu Cadastro Lev">' +
      '<h2>Menu</h2>' +
      '<h3>Sua bike</h3>' +
      '<button type="button" class="linkish" data-nav="home">Início</button>' +
      '<button type="button" class="linkish" data-nav="montagem">Manual de montagem e uso</button>' +
      '<button type="button" class="linkish" data-nav="registro">Cadastrar minha bike</button>' +
      '<h3>Precisa de ajuda?</h3>' +
      '<a href="/pages/perguntas-frequentes" target="_blank" rel="noopener">Dúvidas frequentes</a>' +
      '<a href="/pages/lojas" target="_blank" rel="noopener">Lojas e oficinas</a>' +
      '<a href="/pages/fale-com-a-oficina" target="_blank" rel="noopener">Fale com a oficina</a>' +
      '<a href="https://wa.me/' +
      escapeHtml(WA) +
      '" target="_blank" rel="noopener">Falar no WhatsApp</a>' +
      '</div></div>'
    );
  }

  function whatsappHelp(chamada) {
    return (
      '<a class="lev-cadastrolev__whatsapp-help" href="https://wa.me/' +
      escapeHtml(WA) +
      '" target="_blank" rel="noopener"><span class="lev-cadastrolev__whatsapp-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" fill="white"></path></svg>' +
      '</span><span><strong>' +
      escapeHtml(chamada || 'Ficou com dúvida? Fale com a gente') +
      '</strong><small>Menu → Opção 1 → Cliente Magalu</small></span></a>'
    );
  }

  function renderHome() {
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--home">' +
      logoHtml(true) +
      corsBanner() +
      '<div class="lev-cadastrolev__content lev-cadastrolev__content--home">' +
      '<div class="lev-cadastrolev__home-hero">' +
      '<h1 class="lev-cadastrolev__title">Parabéns<br>pela Compra!</h1>' +
      dots(0, 2) +
      '<p class="lev-cadastrolev__lead">Agora você faz parte da família Lev!</p>' +
      '</div>' +
      '<div class="lev-cadastrolev__cards lev-cadastrolev__home-cards">' +
      '<button type="button" class="lev-cadastrolev__card lev-cadastrolev__home-card lev-cadastrolev__home-card--manual" data-nav="montagem">' +
      '<span class="lev-cadastrolev__home-card-image">' +
      '<img src="' +
      escapeHtml(asset('/cadastrolev-assets/manual-hero-desktop.png')) +
      '" alt="Manual de Montagem">' +
      '</span>' +
      '<span class="lev-cadastrolev__card-body lev-cadastrolev__home-card-content">' +
      '<strong>Manual de Montagem e uso</strong>' +
      '<span class="lev-cadastrolev__home-card-cta">Assistir Agora' +
      '<img src="' +
      escapeHtml(asset('/cadastrolev-assets/button-advance.svg')) +
      '" alt="" width="28" height="28"></span></span>' +
      '</button>' +
      '<button type="button" class="lev-cadastrolev__card lev-cadastrolev__home-card lev-cadastrolev__home-card--benefits" data-nav="registro">' +
      '<span class="lev-cadastrolev__home-card-image">' +
      '<img src="' +
      escapeHtml(asset('/cadastrolev-assets/beneficios-hero-desktop.png')) +
      '" alt="Benefícios">' +
      '</span>' +
      '<span class="lev-cadastrolev__card-body lev-cadastrolev__home-card-content">' +
      '<strong>Acessar<br>Meus Benefícios</strong>' +
      '<span class="lev-cadastrolev__home-card-cta">Receber Agora' +
      '<img src="' +
      escapeHtml(asset('/cadastrolev-assets/button-advance.svg')) +
      '" alt="" width="28" height="28"></span></span>' +
      '</button>' +
      '</div><a class="lev-cadastrolev__chip" href="/pages/perguntas-frequentes" target="_blank" rel="noopener">Dúvidas frequentes</a></div></div>' +
      drawerHtml()
    );
  }

  function renderMontagem() {
    var model = MODEL_DATA[state.montagemModel] || MODEL_DATA.cruiser;
    var tabs = Object.keys(MODEL_DATA)
      .map(function (key) {
        return (
          '<button type="button" class="lev-cadastrolev__montage-model ' +
          (key === state.montagemModel ? 'is-active' : '') +
          '" data-model="' +
          key +
          '"><span>' +
          escapeHtml(MODEL_DATA[key].label) +
          '</span><img src="' +
          escapeHtml(asset(MODEL_DATA[key].image)) +
          '" alt="" width="94" height="63"></button>'
        );
      })
      .join('');
    var mobileVideos = model.videos
      .slice()
      .reverse()
      .map(function (v) {
        return (
          '<div class="lev-cadastrolev__montage-video-item"><div class="lev-cadastrolev__montage-video-card"><iframe src="' +
          escapeHtml(v.embed) +
          '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="' +
          escapeHtml(v.title) +
          '" loading="lazy"></iframe></div></div>'
        );
      })
      .join('');
    var desktopVideos = model.videos
      .map(function (v, index) {
        return (
          '<div class="lev-cadastrolev__montage-tutorial">' +
          dots(0, 2) +
          '<p>' +
          (index === 0 ? 'Tutorial de Montagem' : 'Tutorial de Uso') +
          '</p><div class="lev-cadastrolev__montage-video-card"><iframe src="' +
          escapeHtml(v.embed) +
          '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="' +
          escapeHtml(v.title) +
          '" loading="lazy"></iframe></div></div>'
        );
      })
      .join('');
    var benefitCard =
      '<button type="button" class="lev-cadastrolev__montage-benefit" data-nav="registro">' +
      '<span class="lev-cadastrolev__montage-benefit-image"><img src="' +
      escapeHtml(asset('/cadastrolev-assets/beneficios-hero.jpg')) +
      '" alt=""></span><span class="lev-cadastrolev__montage-benefit-content"><strong>Cadastrar<br>Minha Bike</strong>' +
      '<span class="lev-cadastrolev__montage-benefit-cta">Cadastrar Agora<span><img src="' +
      escapeHtml(asset('/cadastrolev-assets/arrow-right.svg')) +
      '" alt="" width="12" height="12"></span></span></span></button>';
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--montage">' +
      '<div class="lev-cadastrolev__montage-top-benefit">' +
      benefitCard +
      '</div><div class="lev-cadastrolev__montage-inner">' +
      '<div class="lev-cadastrolev__montage-nav">' +
      '<button type="button" class="lev-cadastrolev__flow-back" data-nav="home"><span><img src="' +
      escapeHtml(asset('/cadastrolev-assets/arrow-left.svg')) +
      '" alt="" width="10" height="18"></span>Voltar</button>' +
      '<button type="button" class="lev-cadastrolev__montage-benefits-link" data-nav="registro">Cadastrar minha bike</button>' +
      menuButtonHtml() +
      '</div><div class="lev-cadastrolev__montage-logo"><img class="lev-cadastrolev__logo" src="' +
      escapeHtml(asset('/cadastrolev-assets/logo-grupo.svg')) +
      '" alt="Grupo Lev onn"></div>' +
      '<div class="lev-cadastrolev__montage-content"><div class="lev-cadastrolev__montage-column">' +
      '<section class="lev-cadastrolev__montage-section"><div class="lev-cadastrolev__flow-heading"><h1 class="lev-cadastrolev__title">Veja como montar e usar sua Lev/Onn</h1>' +
      dots(0, 2) +
      '</div><p class="lev-cadastrolev__lead"><span class="lev-cadastrolev__montage-mobile-copy">Escolha o modelo</span><span class="lev-cadastrolev__montage-desktop-copy">Escolha o modelo abaixo:</span></p>' +
      '<div class="lev-cadastrolev__montage-models">' +
      tabs +
      '</div></section>' +
      '<div class="lev-cadastrolev__montage-downloads"><p>Manuais</p>' +
      '<a class="lev-cadastrolev__manual-link" href="' +
      escapeHtml(asset(model.pdf)) +
      '" target="_blank" rel="noopener"><strong>Manual do produto <b>' +
      escapeHtml(model.label) +
      '</b></strong></a>' +
      '<a class="lev-cadastrolev__manual-link" href="' +
      escapeHtml(guiaPdf()) +
      '" target="_blank" rel="noopener"><span><strong>Manual de <b>Boas Práticas</b></strong><span>Bateria, revisões, calibragem, limpeza e trânsito</span></span></a>' +
      '</div><div class="lev-cadastrolev__montage-videos-mobile">' +
      mobileVideos +
      '</div><div class="lev-cadastrolev__montage-videos-desktop">' +
      desktopVideos +
      '</div>' +
      benefitCard +
      '</div></div></div></div>' +
      drawerHtml()
    );
  }

  function renderCadastroForm() {
    var p = Object.assign(
      {
        nome: '',
        telefone: '',
        email: '',
        cpf: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        dia: '',
        mes: '',
        ano: '',
        termos: false,
        promocionais: false,
      },
      state.personalData || {}
    );
    try {
      var saved = localStorage.getItem(FORM_KEY);
      if (saved) p = Object.assign(p, JSON.parse(saved));
    } catch (e) {
      /* ignore */
    }
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--form">' +
      flowHeaderHtml(1) +
      corsBanner() +
      '<div class="lev-cadastrolev__content lev-cadastrolev__content--form">' +
      '<div class="lev-cadastrolev__flow-heading"><h1 class="lev-cadastrolev__title">Preencha e receba<br>os benefícios</h1>' +
      dots(0, 2) +
      '</div>' +
      (state.statusMsg ? '<p class="lev-cadastrolev__error">' + escapeHtml(state.statusMsg) + '</p>' : '') +
      '<form class="lev-cadastrolev__form" data-form="cadastro">' +
      field('nome', 'Nome Completo / Razão Social', p.nome, 'text', 'Nome Completo') +
      field('cpf', 'CPF/CNPJ', p.cpf, 'tel', '000.000.000-00') +
      field('telefone', 'Telefone', p.telefone, 'tel') +
      field('email', 'E-mail', p.email, 'email', '@golev.com.br') +
      '<div class="lev-cadastrolev__field"><label>Data de Nascimento</label><div class="lev-cadastrolev__date-row">' +
      '<input name="dia" maxlength="2" placeholder="DD" value="' +
      escapeHtml(p.dia) +
      '">' +
      '<input name="mes" maxlength="2" placeholder="MM" value="' +
      escapeHtml(p.mes) +
      '">' +
      '<input name="ano" maxlength="4" placeholder="AAAA" value="' +
      escapeHtml(p.ano) +
      '">' +
      '</div></div>' +
      field('cep', 'CEP', p.cep, 'text', '00000-000') +
      '<p class="lev-cadastrolev__field-feedback" data-cep-feedback aria-live="polite"></p>' +
      field('endereco', 'Endereço', p.endereco) +
      field('numero', 'Número', p.numero, 'text', 'Número') +
      field('complemento', 'Complemento', p.complemento, 'text', 'Número; casa; apto') +
      '<label class="lev-cadastrolev__check"><input type="checkbox" name="termos" ' +
      (p.termos ? 'checked' : '') +
      '> Estou de acordo com os termos e compromisso e políticas de privacidade</label>' +
      '<label class="lev-cadastrolev__check"><input type="checkbox" name="promocionais" ' +
      (p.promocionais ? 'checked' : '') +
      '> Aceito receber e-mails promocionais</label>' +
      '<div class="lev-cadastrolev__actions">' +
      '<button type="submit" class="lev-cadastrolev__cta"' +
      (state.busy ? ' disabled' : '') +
      '>' +
      (state.busy ? 'Salvando...' : 'Próximo') +
      '</button>' +
      '</div></form></div></div>' +
      drawerHtml()
    );
  }

  function field(name, label, value, type, placeholder) {
    return (
      '<div class="lev-cadastrolev__field"><label for="cl-' +
      name +
      '">' +
      escapeHtml(label) +
      '</label><input id="cl-' +
      name +
      '" name="' +
      name +
      '" type="' +
      (type || 'text') +
      '" placeholder="' +
      escapeHtml(placeholder || (name === 'telefone' ? '(xx) xxxx-xxxx' : '')) +
      '" value="' +
      escapeHtml(value || '') +
      '" autocomplete="on"></div>'
    );
  }

  function setCepFeedback(form, message, isError) {
    var feedback = form && form.querySelector('[data-cep-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.classList.toggle('is-error', !!isError);
  }

  function buildAddressFromCep(data) {
    var street = [data.logradouro, data.bairro].filter(Boolean).join(', ');
    var city = [data.localidade, data.uf].filter(Boolean).join(' - ');
    return [street, city].filter(Boolean).join(', ');
  }

  async function fetchAddressByCep(form, cep) {
    var cleanCep = onlyDigits(cep);
    if (!form || cleanCep.length !== 8) return;
    if (cleanCep === lastRequestedCep && form.endereco.value.trim()) return;

    lastRequestedCep = cleanCep;
    var requestSequence = ++cepRequestSequence;
    form.endereco.value = '';
    setCepFeedback(form, 'Buscando...', false);

    try {
      var response = await fetch('https://viacep.com.br/ws/' + cleanCep + '/json/', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('cep_lookup_failed');
      var data = await response.json();
      if (requestSequence !== cepRequestSequence) return;
      if (!data || data.erro) {
        form.endereco.value = '';
        setCepFeedback(form, 'CEP não encontrado', true);
        return;
      }

      var fullAddress = buildAddressFromCep(data);
      if (!fullAddress) throw new Error('cep_without_address');
      form.endereco.value = fullAddress;
      setCepFeedback(form, '', false);
    } catch (error) {
      if (requestSequence !== cepRequestSequence) return;
      form.endereco.value = '';
      setCepFeedback(form, 'Erro ao buscar CEP. Tente novamente.', true);
    }
  }

  function renderNota() {
    var draft = state.nfDraft;
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--nota">' +
      flowHeaderHtml(2, 'lev-cadastrolev__nota-header') +
      corsBanner() +
      '<div class="lev-cadastrolev__content lev-cadastrolev__content--nota">' +
      '<div class="lev-cadastrolev__nota-intro"><div class="lev-cadastrolev__flow-heading"><h1 class="lev-cadastrolev__title">Envie a sua Nota Fiscal</h1>' +
      dots(0, 2) +
      '</div><p class="lev-cadastrolev__lead">É com ela que liberamos o cupom de 15%. Pode ser o PDF que a loja mandou por<br> e-mail ou uma foto da nota impressa.</p></div>' +
      (state.statusMsg ? '<p class="lev-cadastrolev__error">' + escapeHtml(state.statusMsg) + '</p>' : '') +
      '<div class="lev-cadastrolev__nota-upload">' +
      '<p class="lev-cadastrolev__nota-label">Anexe o PDF ou a foto da sua NF (máx. 10 MB)</p>' +
      '<p class="lev-cadastrolev__nota-hint">Deixe a nota bem iluminada e inteira na imagem.</p>' +
      (draft
        ? '<div class="lev-cadastrolev__nota-attached"><p>Arquivo Anexado</p><div>' +
          '<span class="lev-cadastrolev__nota-preview">' +
          (draft.previewDataUrl
            ? '<img src="' + escapeHtml(draft.previewDataUrl) + '" alt="">'
            : '<b>PDF</b>') +
          '</span><strong>' +
          escapeHtml(draft.nomeArquivo || draft.caminho) +
          '</strong></div></div>'
        : '') +
      '<label class="lev-cadastrolev__nota-file" for="cl-nf">' +
      '<input id="cl-nf" type="file" accept="application/pdf,image/jpeg,image/jpg,image/png,image/webp,image/heic,image/heif" data-action="nf-file">' +
      '<img src="' +
      escapeHtml(asset('/cadastrolev-assets/attach-file.svg')) +
      '" alt="" width="24" height="24"><span>' +
      (draft ? 'Clique aqui para mudar o arquivo' : 'Clique ou toque para enviar a nota') +
      '</span></label></div>' +
      whatsappHelp('Não está com a Nota Fiscal? Fale com a gente!') +
      '</div><div class="lev-cadastrolev__nota-footer">' +
      '<button type="button" class="lev-cadastrolev__cta lev-cadastrolev__nota-next" data-action="nf-continue"' +
      (state.busy || !draft ? ' disabled' : '') +
      '>' +
      (state.busy ? 'Enviando…' : 'Próximo') +
      (state.busy || !draft
        ? ''
        : '<img src="' + escapeHtml(asset('/cadastrolev-assets/arrow-right.svg')) + '" alt="" width="12" height="12">') +
      '</button></div></div>' +
      drawerHtml()
    );
  }

  function syncFlowType() {
    state.flowType = window.matchMedia('(min-width: 561px)').matches ? 'desktop' : 'mobile';
  }

  function renderHowTo() {
    syncFlowType();
    var serialReady = String(state.bikeSerialNumber || '').length === 9;
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--howto">' +
      flowHeaderHtml(3) +
      '<div class="lev-cadastrolev__content lev-cadastrolev__content--howto">' +
      '<div class="lev-cadastrolev__howto-pre"><div class="lev-cadastrolev__flow-heading"><h1 class="lev-cadastrolev__title">Escaneie o QR code com o número de série</h1>' +
      dots(0, 2) +
      '<div class="lev-cadastrolev__howto-description"><p class="lev-cadastrolev__lead">O Número de série é composto por uma sequência de 9 letras.</p></div></div>' +
      '<div class="lev-cadastrolev__howto-location"><p class="lev-cadastrolev__section-label">Verifique abaixo a localização do QR code:</p>' +
      '<div class="lev-cadastrolev__howto-video-frame"><video class="lev-cadastrolev__video lev-cadastrolev__howto-video" data-action="replay-howto" aria-label="Demonstração da localização do QR code na bike" autoplay muted playsinline preload="auto" src="' +
      escapeHtml(asset('/cadastrolev-assets/video/qrvideomob1.mp4')) +
      '"></video></div></div>' +
      '<form id="cl-howto-serial" class="lev-cadastrolev__form lev-cadastrolev__howto-serial" data-form="serial-desktop">' +
      '<label class="lev-cadastrolev__howto-serial-label" for="cl-howto-serial-input">Digite o número de série</label>' +
      '<div class="lev-cadastrolev__howto-serial-input"><div class="lev-cadastrolev__howto-serial-input-wrap"><input id="cl-howto-serial-input" type="text" name="serial" value="' +
      escapeHtml(state.bikeSerialNumber) +
      '" placeholder="AAAAAAAAA" maxlength="9" autocomplete="off"></div></div></form>' +
      (state.statusMsg ? '<p class="lev-cadastrolev__error">' + escapeHtml(state.statusMsg) + '</p>' : '') +
      '</div>' +
      '<button type="submit" form="cl-howto-serial" class="lev-cadastrolev__cta lev-cadastrolev__flow-next lev-cadastrolev__howto-next"' +
      (state.busy || !serialReady ? ' disabled' : '') +
      '>' +
      (state.busy ? 'Validando...' : 'Próximo') +
      '<img src="' + escapeHtml(asset('/cadastrolev-assets/arrow-right.svg')) + '" alt="" width="12" height="12"></button></div>' +
      '<button type="button" class="lev-cadastrolev__cta lev-cadastrolev__howto-scan" data-action="scan-qr"><img src="' +
      escapeHtml(asset('/cadastrolev-assets/qr-scanner-icon.svg')) +
      '" alt="" width="24" height="24">Escanear QR Code</button></div>' +
      drawerHtml()
    );
  }

  function renderQrOrSerie(isQr) {
    if (isQr) {
      return (
        '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--qr">' +
        flowHeaderHtml(3) +
        corsBanner() +
        '<div class="lev-cadastrolev__content lev-cadastrolev__content--qr">' +
        '<div class="lev-cadastrolev__qr-preview" data-qr-preview>' +
        '<video class="lev-cadastrolev__qr-video" data-qr-video playsinline muted autoplay></video>' +
        '<div class="lev-cadastrolev__qr-overlay" data-qr-overlay><span>Iniciando câmera…</span></div>' +
        '<p class="lev-cadastrolev__qr-error" data-qr-error hidden></p>' +
        '<div class="lev-cadastrolev__qr-retry" data-qr-retry hidden>' +
        '<button type="button" class="lev-cadastrolev__qr-retry-btn" data-action="retry-camera" aria-label="Reiniciar câmera">' +
        '<img src="' +
        escapeHtml(asset('/cadastrolev-assets/camera-icon.svg')) +
        '" alt="" width="24" height="24"></button>' +
        '<span>Reiniciar Câmera</span></div></div></div>' +
        '<div class="lev-cadastrolev__qr-choices">' +
        '<button type="button" class="lev-cadastrolev__cta lev-cadastrolev__qr-manual" data-action="type-serial"><img src="' +
        escapeHtml(asset('/cadastrolev-assets/keyboard-icon-blue.svg')) +
        '" alt="" width="24" height="24">Digitar Número de Série</button></div></div>' +
        drawerHtml()
      );
    }
    syncFlowType();
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--serial">' +
      flowHeaderHtml(3) +
      corsBanner() +
      '<div class="lev-cadastrolev__content lev-cadastrolev__content--serial">' +
      '<div class="lev-cadastrolev__flow-heading"><h1 class="lev-cadastrolev__title">Digitar<br>número de série</h1>' +
      dots(0, 2) +
      '</div>' +
      (state.statusMsg ? '<p class="lev-cadastrolev__error">' + escapeHtml(state.statusMsg) + '</p>' : '') +
      '<form id="lev-cadastrolev-serial-form" class="lev-cadastrolev__form lev-cadastrolev__serial-form" data-form="serial">' +
      field('serial', 'Não conseguiu? Faça manualmente.', state.bikeSerialNumber, 'text', 'AAAAAAAAA') +
      '</form></div>' +
      '<div class="lev-cadastrolev__serial-actions">' +
      '<button type="submit" form="lev-cadastrolev-serial-form" class="lev-cadastrolev__cta lev-cadastrolev__flow-next" data-action="submit-serial"' +
      (state.busy ? ' disabled' : '') +
      '>' +
      (state.busy ? 'Validando...' : 'Próximo') +
      '<img src="' + escapeHtml(asset('/cadastrolev-assets/arrow-right.svg')) + '" alt="" width="12" height="12"></button>' +
      '<span class="lev-cadastrolev__howto-or lev-cadastrolev__serial-or-mobile">ou</span>' +
      '<button type="button" class="lev-cadastrolev__cta lev-cadastrolev__howto-scan lev-cadastrolev__serial-scan-mobile" data-action="scan-qr"><img src="' +
      escapeHtml(asset('/cadastrolev-assets/qr-scanner-icon.svg')) +
      '" alt="" width="24" height="24">Escanear QR Code</button></div></div>' +
      drawerHtml()
    );
  }

  function renderErro(ativado) {
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--error lev-cadastrolev__shell--error--' +
      (ativado ? 'activated' : 'invalid') +
      '">' +
      flowHeaderHtml(3) +
      '<div class="lev-cadastrolev__content lev-cadastrolev__content--error">' +
      '<div class="lev-cadastrolev__flow-heading"><h1 class="lev-cadastrolev__title">' +
      (ativado ? 'Qr Code<br>já cadastrado' : 'Número de<br>série inválido') +
      '</h1>' +
      dots(0, 2) +
      '<p class="lev-cadastrolev__lead">' +
      escapeHtml(
        state.validationMessage ||
          (ativado
            ? 'Esse Qr-Code já foi cadastrado! Tente novamente.'
            : state.flowType === 'desktop'
              ? 'Digite novamente o número de série.'
              : 'Escaneie ou digite novamente o número de série.')
      ) +
      '</p></div></div>' +
      '<div class="lev-cadastrolev__error-actions">' +
      '<button type="button" class="lev-cadastrolev__error-digit" data-action="prev"><img src="' +
      escapeHtml(asset(ativado ? '/cadastrolev-assets/keyboard-icon-blue.svg' : '/cadastrolev-assets/keyboard-icon-fill.svg')) +
      '" alt="" width="24" height="24">Digitar Número de Série</button>' +
      (state.flowType === 'desktop'
        ? ''
        : '<span class="lev-cadastrolev__error-or">ou</span><button type="button" class="lev-cadastrolev__error-scan" data-action="retry-scan"><img src="' +
          escapeHtml(asset(ativado ? '/cadastrolev-assets/qr-scanner-icon.svg' : '/cadastrolev-assets/qr-scanner-icon-fill.svg')) +
          '" alt="" width="24" height="24">Escanear QR Code</button>') +
      whatsappHelp(ativado ? 'Essa bike já é sua? Fale com a gente' : 'O número não foi aceito? Fale com a gente') +
      '</div></div>' +
      drawerHtml()
    );
  }

  function renderValidado() {
    var b = state.bikeData || {};
    var modelo = (state.bikeImage && state.bikeImage.bikeModel) || b.produto || '';
    var isFigmaCruiser = /cruiser\s*c/i.test(modelo);
    var img = isFigmaCruiser
      ? asset('/cadastrolev-assets/bikes/validated-cruiser.png')
      : state.bikeImage && state.bikeImage.imagePath
        ? asset(state.bikeImage.imagePath)
        : '';
    var ctaLabel = state.busy
      ? 'Conferindo nota e finalizando…'
      : state.statusMsg
        ? 'Tentar de novo'
        : 'Próximo';
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--validated">' +
      validatedHeaderHtml() +
      corsBanner() +
      '<div class="lev-cadastrolev__content lev-cadastrolev__content--validated">' +
      '<div class="lev-cadastrolev__flow-heading"><h1 class="lev-cadastrolev__title">Número de<br>série validado!</h1>' +
      dots(0, 2) +
      '</div>' +
      '<div class="lev-cadastrolev__validated-serial"><p>Número de Série</p><strong>' +
      escapeHtml(state.bikeSerialNumber || b.nroSerie || '—') +
      '</strong></div>' +
      (modelo
        ? '<div class="lev-cadastrolev__validated-bike"><p>Sua e-bike é uma:</p><div class="lev-cadastrolev__validated-card"><div class="lev-cadastrolev__validated-card-header"><h2>' +
          escapeHtml(modelo) +
          '</h2></div><div class="lev-cadastrolev__validated-card-image' +
          (isFigmaCruiser ? ' lev-cadastrolev__validated-card-image--figma' : '') +
          '">' +
          (img
            ? '<img class="lev-cadastrolev__bike-img" src="' +
              escapeHtml(img) +
              '" alt="' +
              escapeHtml(modelo + (b.cor ? ' - ' + b.cor : '')) +
              '">'
            : '') +
          '</div></div>' +
          (state.statusMsg && !state.nfWhatsapp ? validatedAlertHtml(state.statusMsg) : '') +
          '</div>'
        : '') +
      (!modelo && state.statusMsg && !state.nfWhatsapp ? validatedAlertHtml(state.statusMsg) : '') +
      '</div><div class="lev-cadastrolev__validated-footer">' +
      (state.nfWhatsapp
        ? '<div class="lev-cadastrolev__validated-redirect" role="status" aria-live="polite"><h2>Vamos te ajudar pelo WhatsApp</h2><p>Não conseguimos confirmar sua nota depois de duas tentativas. Fale com um atendente da Lev para concluir seu cadastro.</p><p>Menu → Opção 1 → Cliente Magalu</p><a class="lev-cadastrolev__validated-whatsapp" href="https://wa.me/' +
          escapeHtml(WA) +
          '" target="_blank" rel="noopener">Abrir WhatsApp agora</a></div>'
        : '<button type="button" class="lev-cadastrolev__cta lev-cadastrolev__flow-next" data-action="register"' +
          (state.busy ? ' disabled' : '') +
          '>' +
          escapeHtml(ctaLabel) +
          (state.busy
            ? ''
            : '<img src="' + escapeHtml(asset('/cadastrolev-assets/arrow-right-blue.svg')) + '" alt="" width="12" height="12">') +
          '</button>') +
      '</div></div>' +
      drawerHtml()
    );
  }

  function validatedAlertHtml(message) {
    return (
      '<div class="lev-cadastrolev__validated-alert" role="alert" aria-live="polite"><p>' +
      escapeHtml(message) +
      '</p><button type="button" data-action="restart-registration">Recomeçar o cadastro do início</button></div>'
    );
  }

  function renderFinal() {
    return (
      '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--final">' +
      logoHtml(false) +
      '<div class="lev-cadastrolev__content lev-cadastrolev__content--final">' +
      '<div class="lev-cadastrolev__final-intro"><div class="lev-cadastrolev__flow-heading"><h1 class="lev-cadastrolev__title">Seus benefícios<br>foram liberados!</h1>' +
      dots(0, 2) +
      '</div>' +
      '<p class="lev-cadastrolev__lead">Confira seu e-mail e utilize o cupom de 15% de desconto para compras de acessórios no nosso site ou nas lojas físicas da Lev e da Onn.</p></div>' +
      '<p class="lev-cadastrolev__lead lev-cadastrolev__final-reminder"><strong>Guarde o Cupom e o Número de Série que<br>enviamos para o seu e-mail.</strong></p>' +
      '<div class="lev-cadastrolev__benefit"><div><strong>15<span>%</span> desconto</strong><small>Válido somente por 90 dias</small></div><p>1ª Compra de Acessórios</p></div>' +
      '</div><div class="lev-cadastrolev__final-footer"><div class="lev-cadastrolev__final-secondary">' +
      '<a class="lev-cadastrolev__manual-link" href="' +
      escapeHtml(guiaPdf()) +
      '" target="_blank" rel="noopener"><span><strong>Manual de <b>Boas Práticas</b></strong><span>Como cuidar da bateria e da sua bike</span></span></a>' +
      whatsappHelp() +
      '</div><div class="lev-cadastrolev__actions lev-cadastrolev__final-actions">' +
      '<a class="lev-cadastrolev__cta" href="/collections/acessorios" target="_blank" rel="noopener">Ver Acessórios<img src="' +
      escapeHtml(asset('/cadastrolev-assets/arrow-right.svg')) +
      '" alt="" width="12" height="12"></a>' +
      '</div></div></div>' +
      drawerHtml()
    );
  }

  function renderRegistro() {
    switch (state.step) {
      case STEP.INICIO:
        return (
          '<div class="lev-cadastrolev__shell lev-cadastrolev__shell--start">' +
          logoHtml(false) +
          '<div class="lev-cadastrolev__content lev-cadastrolev__content--start">' +
          '<div class="lev-cadastrolev__flow-heading lev-cadastrolev__start-intro"><h1 class="lev-cadastrolev__title">Receba seus Benefícios</h1>' +
          dots(0, 2) +
          '<p class="lev-cadastrolev__lead">Você já faz parte do movimento que está mudando as cidades. Agora é hora de ativar as vantagens que vêm junto com a sua bike.</p></div>' +
          '<div class="lev-cadastrolev__start-benefits"><p class="lev-cadastrolev__section-label">Em poucos passos, você garante:</p>' +
          '<div class="lev-cadastrolev__start-benefit"><div><strong><b>15</b><span>%</span><b> desconto</b></strong><small>Válido somente por 90 dias</small></div><p>1ª Compra de Acessórios</p></div></div>' +
          '<p class="lev-cadastrolev__lead lev-cadastrolev__start-closing">O cadastro leva menos de 1 minuto.<br>Vamos começar?</p>' +
          '</div><div class="lev-cadastrolev__actions lev-cadastrolev__start-actions">' +
          '<button type="button" class="lev-cadastrolev__cta lev-cadastrolev__start-cta" data-action="next">Iniciar' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M4.5 3L7.5 6L4.5 9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>' +
          '</div></div>' +
          drawerHtml()
        );
      case STEP.CADASTRO:
        return renderCadastroForm();
      case STEP.NOTA_FISCAL:
        return renderNota();
      case STEP.HOWTO:
        return renderHowTo();
      case STEP.QRCODE:
        return renderQrOrSerie(true);
      case STEP.SERIE:
        return renderQrOrSerie(false);
      case STEP.ERRO_SERIE:
        return renderErro(false);
      case STEP.ERRO_ATIVADA:
        return renderErro(true);
      case STEP.VALIDADO:
      case STEP.CONFERIR_NF:
        return renderValidado();
      case STEP.FINAL:
        return renderFinal();
      default:
        state.step = STEP.INICIO;
        return renderRegistro();
    }
  }

  var qrScanner = null;
  var qrProcessing = false;

  function setQrUi(opts) {
    var overlay = ROOT.querySelector('[data-qr-overlay]');
    var errorEl = ROOT.querySelector('[data-qr-error]');
    var retry = ROOT.querySelector('[data-qr-retry]');
    var video = ROOT.querySelector('[data-qr-video]');
    if (overlay) {
      overlay.hidden = !opts.loading;
      if (opts.loading) overlay.querySelector('span').textContent = opts.loadingText || 'Iniciando câmera…';
    }
    if (errorEl) {
      if (opts.error) {
        errorEl.hidden = false;
        errorEl.textContent = opts.error;
      } else {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }
    if (retry) retry.hidden = !opts.error;
    if (video) video.classList.toggle('is-live', !!opts.live);
  }

  function stopQrScanner() {
    if (qrScanner) {
      try {
        qrScanner.stop();
      } catch (e) {
        /* ignore */
      }
      try {
        qrScanner.destroy();
      } catch (e) {
        /* ignore */
      }
      qrScanner = null;
    }
    qrProcessing = false;
    var video = ROOT.querySelector('[data-qr-video]');
    if (video && video.srcObject) {
      try {
        video.srcObject.getTracks().forEach(function (track) {
          track.stop();
        });
      } catch (e) {
        /* ignore */
      }
      video.srcObject = null;
    }
  }

  async function handleQrPayload(data) {
    if (qrProcessing) return;
    var clean = String(data || '')
      .replace(/[^a-zA-Z]/g, '')
      .toUpperCase();
    if (clean.length !== 9) {
      setQrUi({
        live: true,
        loading: false,
        error: 'Esse QR não é o do quadro da bike. Procure o adesivo com 9 letras — ou digite o número.',
      });
      return;
    }
    qrProcessing = true;
    stopQrScanner();
    state.flowType = 'mobile';
    await validateSerial(clean);
  }

  async function waitForQrScanner(timeoutMs) {
    if (typeof window.QrScanner !== 'undefined') return window.QrScanner;
    return new Promise(function (resolve, reject) {
      var done = false;
      function finish(ok, value) {
        if (done) return;
        done = true;
        window.removeEventListener('lev-qr-scanner-ready', onReady);
        if (ok) resolve(value);
        else reject(value);
      }
      function onReady() {
        finish(true, window.QrScanner);
      }
      window.addEventListener('lev-qr-scanner-ready', onReady);
      setTimeout(function () {
        if (typeof window.QrScanner !== 'undefined') finish(true, window.QrScanner);
        else finish(false, new Error('QrScanner load timeout'));
      }, timeoutMs || 8000);
    });
  }

  async function startQrScanner() {
    if (state.view !== 'registro' || state.step !== STEP.QRCODE) return;
    var video = ROOT.querySelector('[data-qr-video]');
    if (!video) return;

    stopQrScanner();
    // Keep the video element visible — qr-scanner pauses Safari if display:none.
    video.style.display = 'block';
    video.style.opacity = '1';
    video.style.width = '100%';
    video.style.height = '100%';
    setQrUi({ loading: true, live: false });

    var host = location.hostname;
    var secureOk =
      location.protocol === 'https:' || host === 'localhost' || host === '127.0.0.1';
    if (!secureOk) {
      setQrUi({
        loading: false,
        live: false,
        error: 'A câmera só funciona em conexão segura (https). Digite o número de série.',
      });
      return;
    }
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setQrUi({
        loading: false,
        live: false,
        error: 'Este navegador não abre a câmera. Digite o número de série.',
      });
      return;
    }

    var Scanner;
    try {
      Scanner = await waitForQrScanner(8000);
    } catch (loadError) {
      setQrUi({
        loading: false,
        live: false,
        error: 'Não foi possível carregar o leitor de QR. Digite o número de série.',
      });
      return;
    }
    if (!Scanner) {
      setQrUi({
        loading: false,
        live: false,
        error: 'Não foi possível carregar o leitor de QR. Digite o número de série.',
      });
      return;
    }

    try {
      qrScanner = new Scanner(
        video,
        function (result) {
          var payload = result && result.data != null ? result.data : result;
          void handleQrPayload(payload);
        },
        {
          preferredCamera: 'environment',
          highlightScanRegion: true,
          highlightCodeOutline: true,
          maxScansPerSecond: 3,
          returnDetailedScanResult: true,
        }
      );
      await qrScanner.start();
      video.style.display = 'block';
      video.style.opacity = '1';
      video.style.width = '100%';
      video.style.height = '100%';
      setQrUi({ loading: false, live: true });
    } catch (error) {
      stopQrScanner();
      var message = 'Não foi possível iniciar a câmera. Digite o número de série.';
      if (error && error.name === 'NotAllowedError') {
        message =
          'Permissão de câmera negada. Permita o acesso à câmera nas configurações do navegador.';
      } else if (error && error.name === 'NotFoundError') {
        message = 'Câmera não encontrada neste aparelho.';
      } else if (error && error.name === 'NotReadableError') {
        message = 'A câmera está em uso por outro aplicativo. Feche-o e tente de novo.';
      }
      setQrUi({ loading: false, live: false, error: message });
    }
  }

  function goToSerialStep(opts) {
    opts = opts || {};
    stopQrScanner();
    state.step = STEP.SERIE;
    state.flowType = opts.flowType || state.flowType || 'mobile';
    if (opts.clearSerial) state.bikeSerialNumber = '';
    state.statusMsg = '';
    state.validationMessage = '';
    salvarSessao();
    setHash();
    render();
  }

  function goToQrStep() {
    stopQrScanner();
    state.step = STEP.QRCODE;
    state.flowType = 'mobile';
    state.statusMsg = '';
    state.validationMessage = '';
    salvarSessao();
    setHash();
    render();
  }

  function render() {
    var html;
    stopQrScanner();
    if (state.view === 'montagem') html = renderMontagem();
    else if (state.view === 'registro') html = renderRegistro();
    else html = renderHome();
    ROOT.innerHTML = html;
    if (state.view === 'registro' && state.step === STEP.QRCODE) {
      void startQrScanner();
    }
  }

  function setHash() {
    var hash = '#';
    if (state.view === 'montagem') hash = '#montagem';
    else if (state.view === 'registro') hash = '#registro';
    if (location.hash !== hash) history.replaceState(null, '', hash || location.pathname + location.search);
  }

  function readHash() {
    var h = (location.hash || '').replace(/^#/, '');
    if (h === 'registro') state.view = 'registro';
    else if (h === 'montagem') state.view = 'montagem';
    else state.view = 'home';
  }

  async function goNext(extra) {
    var target = nextStep(state.step);
    if (extra) {
      Object.keys(extra).forEach(function (k) {
        state[k] = extra[k];
      });
      if (extra.bikeSerialNumber && extra.flowType) {
        target = routeAfterValidation({
          alreadyActivated: !!extra.alreadyActivated,
          hasBikeData: !!extra.bikeData,
        });
      }
    }
    state.step = target;
    state.statusMsg = '';
    if (state.cadastroId) {
      salvarSessao();
      void updateEtapaAPI(state.cadastroId, getPageName(target));
    }
    if (target === STEP.FINAL) limparSessao();
    render();
    window.scrollTo(0, 0);
  }

  async function goPrev() {
    state.step = prevStepForFlow(state.step, state.flowType);
    state.statusMsg = '';
    if (state.cadastroId) {
      salvarSessao();
      void updateEtapaAPI(state.cadastroId, getPageName(state.step));
    }
    render();
    window.scrollTo(0, 0);
  }

  async function submitCadastro(form) {
    var data = {
      nome: form.nome.value.trim(),
      telefone: form.telefone.value.trim(),
      email: form.email.value.trim(),
      cpf: form.cpf.value.trim(),
      cep: form.cep.value.trim(),
      endereco: form.endereco.value.trim(),
      numero: form.numero.value.trim(),
      complemento: form.complemento.value.trim(),
      dia: form.dia.value.trim(),
      mes: form.mes.value.trim(),
      ano: form.ano.value.trim(),
      termos: !!form.termos.checked,
      promocionais: !!form.promocionais.checked,
    };
    try {
      localStorage.setItem(FORM_KEY, JSON.stringify(data));
    } catch (e) {
      /* ignore */
    }
    if (!data.termos) {
      state.statusMsg = 'Aceite os termos para continuar.';
      render();
      return;
    }
    if (!data.nome || !data.email || !data.cpf || !data.telefone) {
      state.statusMsg = 'Preencha nome, e-mail, telefone e CPF.';
      render();
      return;
    }
    if (!isValidCpf(data.cpf)) {
      state.statusMsg = 'CPF inválido.';
      render();
      return;
    }
    if (!data.cep) {
      state.statusMsg = 'Por favor, preencha o campo CEP.';
      render();
      return;
    }
    if (!data.endereco) {
      state.statusMsg = 'Por favor, aguarde o carregamento do endereço ou verifique o CEP.';
      render();
      return;
    }
    if (!data.numero) {
      state.statusMsg = 'Por favor, preencha o campo Número.';
      render();
      return;
    }
    if (!data.dia || !data.mes || !data.ano) {
      state.statusMsg = 'Por favor, preencha a data de nascimento.';
      render();
      return;
    }
    state.busy = true;
    state.statusMsg = '';
    render();
    var payload = Object.assign({}, data, {
      data_nascimento:
        data.dia && data.mes && data.ano
          ? data.ano + '-' + data.mes.padStart(2, '0') + '-' + data.dia.padStart(2, '0')
          : undefined,
    });
    try {
      var res = await apiFetch('/api/magalu-cadastro', {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      var result = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) {
        throw new Error(
          customerMessage(result.message || result.error, 'Não foi possível salvar seus dados.')
        );
      }
      state.personalData = data;
      state.cadastroId = result.data && result.data.id ? result.data.id : null;
      state.busy = false;
      await goNext({ personalData: data, cadastroId: state.cadastroId });
    } catch (err) {
      state.busy = false;
      state.statusMsg = err.message || 'Falha de rede ao salvar cadastro.';
      render();
    }
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    // Fallback must still look like a UUID — draftTokenEhValido rejects non-UUID tokens.
    var s = '';
    var i;
    for (i = 0; i < 32; i++) s += Math.floor(Math.random() * 16).toString(16);
    return (
      s.slice(0, 8) +
      '-' +
      s.slice(8, 12) +
      '-4' +
      s.slice(13, 16) +
      '-a' +
      s.slice(17, 20) +
      '-' +
      s.slice(20, 32)
    );
  }

  function mimeDoArquivo(file) {
    var peloTipo = String((file && file.type) || '')
      .split(';')[0]
      .trim()
      .toLowerCase();
    var allowed = {
      'application/pdf': 1,
      'image/jpeg': 1,
      'image/jpg': 1,
      'image/png': 1,
      'image/webp': 1,
      'image/heic': 1,
      'image/heif': 1,
    };
    if (allowed[peloTipo]) return peloTipo === 'image/jpg' ? 'image/jpeg' : peloTipo;
    var ext = String((file && file.name) || '')
      .split('.')
      .pop()
      .trim()
      .toLowerCase();
    var byExt = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      webp: 'image/webp',
      heic: 'image/heic',
      heif: 'image/heif',
    };
    return byExt[ext] || '';
  }

  async function uploadNf(file) {
    if (!file) return;
    state.busy = true;
    state.statusMsg = '';
    render();
    var contentType = mimeDoArquivo(file);
    if (!contentType) {
      state.busy = false;
      state.statusMsg = 'Envie a nota em PDF ou uma foto (JPG, PNG, WEBP ou HEIC).';
      render();
      return;
    }
    var draftToken = (state.nfDraft && state.nfDraft.draftToken) || uuid();
    try {
      var presignRes = await apiFetch('/api/cadastrolev/nf/presign-draft', {
        method: 'POST',
        body: JSON.stringify({
          draftToken: draftToken,
          contentType: contentType,
          size: file.size,
        }),
      });
      var presign = await presignRes.json().catch(function () {
        return {};
      });
      if (!presignRes.ok) {
        throw new Error(
          customerMessage(
            presign.motivo || presign.message || presign.error,
            'Não foi possível preparar o envio da nota.'
          )
        );
      }
      if (!presign.signedUrl || !presign.token) {
        throw new Error('Não foi possível preparar o envio da nota. Tente novamente.');
      }
      var putHeaders = { 'Content-Type': contentType };
      // Supabase signed upload requires the returned token as Bearer.
      putHeaders.Authorization = 'Bearer ' + presign.token;
      var put = await fetch(presign.signedUrl, {
        method: 'PUT',
        headers: putHeaders,
        body: file,
      });
      if (!put.ok) throw new Error('Falha no upload do arquivo.');
      var previewDataUrl = '';
      if (contentType.indexOf('image/') === 0) {
        previewDataUrl = await new Promise(function (resolve) {
          var reader = new FileReader();
          reader.onload = function () {
            resolve(String(reader.result || ''));
          };
          reader.onerror = function () {
            resolve('');
          };
          reader.readAsDataURL(file);
        });
      }
      state.nfDraft = {
        draftToken: draftToken,
        caminho: presign.caminho || '',
        contentType: contentType,
        size: file.size,
        nomeArquivo: file.name,
        previewDataUrl: previewDataUrl,
      };
      writeJson(NF_DRAFT_KEY, Object.assign({}, state.nfDraft, { salvoEm: Date.now() }));
      state.busy = false;
      render();
    } catch (err) {
      state.busy = false;
      state.statusMsg = customerMessage(err.message, 'Não foi possível enviar a nota.');
      render();
    }
  }

  async function validateSerial(serialRaw) {
    var serial = String(serialRaw || '')
      .trim()
      .toUpperCase();
    if (!serial) {
      state.statusMsg = 'Informe o número de série.';
      render();
      return;
    }
    state.busy = true;
    state.statusMsg = '';
    state.bikeSerialNumber = serial;
    render();
    try {
      var res = await apiFetch('/api/sahnkya/validate-bike-serial', {
        method: 'POST',
        body: JSON.stringify({
          serialNumber: serial,
          cpf: state.personalData && state.personalData.cpf,
          cadastroId: state.cadastroId,
        }),
      });
      var data = await res.json().catch(function () {
        return {};
      });
      state.busy = false;
      if (data.code === 'SERIAL_JA_ATIVADO' || /j[aá] cadastrado|ativad/i.test(String(data.message || ''))) {
        state.alreadyActivated = true;
        state.validationMessage = customerMessage(
          data.message,
          'Esse Qr-Code já foi cadastrado! Tente novamente.'
        );
        await goNext({
          bikeSerialNumber: serial,
          flowType: state.flowType,
          alreadyActivated: true,
          bikeData: null,
        });
        return;
      }
      if (!res.ok || !data.data) {
        state.alreadyActivated = false;
      state.validationMessage = customerMessage(
        data.message || data.error,
        'Número de série inválido.'
      );
        await goNext({
          bikeSerialNumber: serial,
          flowType: state.flowType,
          alreadyActivated: false,
          bikeData: null,
        });
        return;
      }
      state.bikeData = data.data;
      state.bikeImage = data.data.produto
        ? { imagePath: '/cadastrolev-assets/bikes/cruiser-1-preto.svg', bikeModel: data.data.produto, color: data.data.cor }
        : null;
      await goNext({
        bikeSerialNumber: serial,
        flowType: state.flowType,
        alreadyActivated: false,
        bikeData: data.data,
        bikeImage: state.bikeImage,
      });
    } catch (err) {
      state.busy = false;
      state.statusMsg = customerMessage(
        err.message,
        'Não foi possível validar o número de série. Tente novamente.'
      );
      render();
    }
  }

  async function registerBike() {
    if (!state.bikeData || !state.bikeSerialNumber) {
      state.statusMsg = 'Valide o número de série antes de finalizar.';
      render();
      return;
    }
    if (!state.cadastroId) {
      state.statusMsg = 'Sessão incompleta. Recomece o cadastro.';
      render();
      return;
    }
    if (!state.nfDraft || !state.nfDraft.caminho) {
      state.statusMsg =
        'Não encontramos sua nota fiscal. Volte e envie o PDF ou a foto de novo.';
      render();
      return;
    }

    var bike = state.bikeData;
    var serial = String(state.bikeSerialNumber || bike.nroSerie || '')
      .trim()
      .toUpperCase();

    state.busy = true;
    state.statusMsg = '';
    state.nfWhatsapp = false;
    render();

    try {
      // Confirm the invoice before reserving the serial number.
      var confirmRes = await apiFetch('/api/cadastrolev/nf/confirmar', {
        method: 'POST',
        body: JSON.stringify({
          cadastroId: state.cadastroId,
          numeroSerie: serial,
          cpf: state.personalData.cpf,
          caminho: state.nfDraft.caminho,
          contentType: state.nfDraft.contentType,
          size: state.nfDraft.size,
          chaveAcesso: state.nfDraft.chaveAcesso || undefined,
          bikeSankhya: {
            produto: bike.produto,
            cor: bike.cor,
            nroSerie: serial,
            nroChassi: bike.nroChassi,
            nroMotor: bike.nroMotor,
            nroBateria: bike.nroBateria,
            qrcodeMotor: bike.qrcodeMotor,
            qrcodeBateria: bike.qrcodeBateria,
          },
        }),
      });
      var confirmData = await confirmRes.json().catch(function () {
        return {};
      });

      if (!confirmRes.ok) {
        state.busy = false;
        if (confirmData.redirecionarWhatsapp || confirmData.error === 'nf_recusada_limite') {
          state.nfWhatsapp = true;
          state.statusMsg =
            customerMessage(
              confirmData.motivo,
              'Não conseguimos confirmar sua nota depois de algumas tentativas. Fale conosco no WhatsApp.'
            );
          render();
          return;
        }
        state.statusMsg =
          customerMessage(
            confirmData.motivo || confirmData.message || confirmData.error,
            'Não foi possível confirmar que esta nota é sua. Envie novamente ou fale com o atendimento.'
          );
        render();
        return;
      }

      // Register only after the invoice has been approved.
      var res = await apiFetch('/api/register-bike', {
        method: 'POST',
        body: JSON.stringify({
          numeroSerie: serial,
          bikeData: bike,
          cadastroId: state.cadastroId,
          email: state.personalData.email,
          cpf: state.personalData.cpf,
          nome: state.personalData.nome,
          telefone: state.personalData.telefone,
        }),
      });
      var data = await res.json().catch(function () {
        return {};
      });
      if (res.status === 409) {
        state.busy = false;
        state.alreadyActivated = true;
        state.validationMessage = customerMessage(
          data.message,
          'Esse Qr-Code já foi cadastrado! Tente novamente.'
        );
        state.step = STEP.ERRO_ATIVADA;
        render();
        return;
      }
      if (!res.ok) {
        throw new Error(
          customerMessage(data.message || data.error, 'Não foi possível registrar a bike.')
        );
      }

      try {
        clearKey(NF_DRAFT_KEY);
      } catch (e) {
        /* ignore */
      }
      state.nfDraft = null;

      await updateCupom(state.cadastroId);
      await updateStatus(state.cadastroId, 'concluido');
      state.busy = false;
      await goNext();
    } catch (err) {
      state.busy = false;
      state.statusMsg = customerMessage(
        err.message,
        'Não foi possível concluir o cadastro. Tente novamente.'
      );
      render();
    }
  }

  ROOT.addEventListener('click', function (event) {
    var t = event.target.closest('[data-nav],[data-action],[data-model]');
    if (!t) {
      if (event.target.classList && event.target.classList.contains('lev-cadastrolev__drawer')) {
        state.menuOpen = false;
        render();
      }
      return;
    }
    if (t.hasAttribute('data-model')) {
      state.montagemModel = t.getAttribute('data-model');
      render();
      return;
    }
    var nav = t.getAttribute('data-nav');
    if (nav) {
      state.menuOpen = false;
      state.view = nav;
      if (nav === 'registro' && state.step === STEP.FINAL) state.step = STEP.INICIO;
      setHash();
      render();
      return;
    }
    var action = t.getAttribute('data-action');
    if (action === 'menu') {
      state.menuOpen = true;
      render();
    } else if (action === 'close-menu') {
      if (event.target === t) {
        state.menuOpen = false;
        render();
      }
    } else if (action === 'next') {
      void goNext();
    } else if (action === 'prev') {
      void goPrev();
    } else if (action === 'nf-continue') {
      void goNext({ nfDraft: state.nfDraft });
    } else if (action === 'scan-qr' || action === 'retry-scan') {
      goToQrStep();
    } else if (action === 'type-serial') {
      goToSerialStep({ clearSerial: state.step === STEP.QRCODE, flowType: 'mobile' });
    } else if (action === 'retry-camera') {
      void startQrScanner();
    } else if (action === 'replay-howto') {
      t.currentTime = 0;
      void t.play().catch(function () {
        /* The next tap can retry if playback is blocked. */
      });
    } else if (action === 'restart-registration') {
      limparSessao();
      state.step = STEP.INICIO;
      state.cadastroId = null;
      state.personalData = {};
      state.bikeSerialNumber = '';
      state.bikeData = null;
      state.bikeImage = null;
      state.nfDraft = null;
      state.alreadyActivated = false;
      state.validationMessage = '';
      state.busy = false;
      state.nfWhatsapp = false;
      state.statusMsg = '';
      setHash();
      render();
    } else if (action === 'register') {
      void registerBike();
    }
  });

  ROOT.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.getAttribute('data-action') === 'nf-file' && input.files && input.files[0]) {
      void uploadNf(input.files[0]);
    }
  });

  ROOT.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.name) return;
    if (input.name === 'cpf') input.value = maskCpf(input.value);
    if (input.name === 'telefone') input.value = maskPhone(input.value);
    if (input.name === 'serial') {
      input.value = String(input.value || '')
        .replace(/[^a-zA-Z]/g, '')
        .toUpperCase()
        .slice(0, 9);
      state.bikeSerialNumber = input.value;
      var howtoNext = ROOT.querySelector('.lev-cadastrolev__howto-next');
      if (howtoNext) howtoNext.disabled = input.value.length !== 9 || state.busy;
      return;
    }
    if (input.name !== 'cep') return;

    input.value = maskCep(input.value);
    var form = input.form;
    var cep = onlyDigits(input.value);
    if (!form) return;
    if (cep.length !== 8) {
      cepRequestSequence += 1;
      lastRequestedCep = '';
      form.endereco.value = '';
      setCepFeedback(form, '', false);
      return;
    }
    void fetchAddressByCep(form, cep);
  });

  ROOT.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    event.preventDefault();
    var kind = form.getAttribute('data-form');
    if (kind === 'cadastro') void submitCadastro(form);
    else if (kind === 'serial' || kind === 'serial-desktop') void validateSerial(form.serial.value);
  });

  window.addEventListener('hashchange', function () {
    readHash();
    render();
  });

  restaurarSessao();
  readHash();
  if (state.view === 'registro' && !state.cadastroId && state.step > STEP.CADASTRO) {
    state.step = STEP.INICIO;
  }
  setHash();
  render();
})();
